import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';

/**
 * Add Location Google Review Input Schema
 */

export const connectAppStoreChannelValidationSchema = z.object({
  apps: z.array(
    z.object({
      id: z.string({ required_error: 'ID is required' }),
      appName: z.string({ required_error: 'App name is required' }),
    })
  ),
});

export type TConnectAppStoreChannelValidation = z.infer<typeof connectAppStoreChannelValidationSchema>;
export type TConnectAppStoreChannelPayload = TConnectAppStoreChannelValidation;
export type TConnectAppStoreChannelResponse = ApiResponse<{
  message: string;
}>;

export const connectAppStoreChannel = async (
  payload: TConnectAppStoreChannelPayload
): Promise<TConnectAppStoreChannelResponse> => {
  const url = `/integration/appstore/app-list`;

  return axiosInstance.post(url, payload);
};

/**
 * Use Add Location Google Review React-Query Hook
 */
type UseConnectAppStoreChannelOptions = {
  mutationConfig?: TypedMutationConfig<typeof connectAppStoreChannel, AxiosErrorCustom>;
};

export const useConnectAppStoreChannel = ({ mutationConfig }: UseConnectAppStoreChannelOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: connectAppStoreChannel,
    ...restConfig,
  });
};
